import type { IconSvgObject } from './types';

const StumbleuponIcon: IconSvgObject = [
  ["path", { d: "M18 13V15C18 16.1046 17.1046 17 16 17C14.8954 17 14 16.1046 14 15V13M6 13V15C6 16.1046 6.89543 17 8 17C9.10457 17 10 16.1046 10 15V9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.5 4.5V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H19.5C20.6046 2.5 21.5 3.39543 21.5 4.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default StumbleuponIcon;
